module.exports = __webpack_public_path__ + "img/c06_unitmerchanttransport_Normal_ua.83c7d909.webp";